// product fallback images utility
import AirConditionerImage from 'assets/product-fallback-images/air-conditioner.svg';
import DishwasherImage from 'assets/product-fallback-images/dishwasher.svg';
import DryerImage from 'assets/product-fallback-images/dryer.svg';
import ErvImage from 'assets/product-fallback-images/erv.svg';
import FireplaceImage from 'assets/product-fallback-images/fireplace.svg';
import FurnaceImage from 'assets/product-fallback-images/furnace.svg';
import GarageOpenerImage from 'assets/product-fallback-images/garage-opener.svg';
import GarbageDisposalImage from 'assets/product-fallback-images/garbage-disposal.svg';
import HeatPumpImage from 'assets/product-fallback-images/heat-pump.svg';
import HoodImage from 'assets/product-fallback-images/hood.svg';
import HumidifierImage from 'assets/product-fallback-images/humidifier.svg';
import MicrowaveImage from 'assets/product-fallback-images/microwave.svg';
import OvenImage from 'assets/product-fallback-images/oven.svg';
import RangeImage from 'assets/product-fallback-images/range.svg';
import RefrigeratorImage from 'assets/product-fallback-images/refrigerator.svg';
import SumpPumpImage from 'assets/product-fallback-images/sump-pump.svg';
import TanklessWaterHeaterImage from 'assets/product-fallback-images/tankless-water-heater.svg';
import ThermostatImage from 'assets/product-fallback-images/thermostat.svg';
import TrashCompactorImage from 'assets/product-fallback-images/trash-compactor.svg';
import WasherImage from 'assets/product-fallback-images/washer.svg';
import WaterHeaterImage from 'assets/product-fallback-images/water-heater.svg';
import WaterSoftenerImage from 'assets/product-fallback-images/water-softner.svg';
import ImageIcon from 'assets/icons/image.svg';

export const fallbackProductImages = {
  air_conditioner: AirConditionerImage,
  dishwasher: DishwasherImage,
  dryer: DryerImage,
  erv: ErvImage,
  fireplace: FireplaceImage,
  furnace: FurnaceImage,
  garage_opener: GarageOpenerImage,
  garbage_disposal: GarbageDisposalImage,
  heat_pump: HeatPumpImage,
  hood: HoodImage,
  humidifier: HumidifierImage,
  microwave: MicrowaveImage,
  oven: OvenImage,
  range: RangeImage,
  refrigerator: RefrigeratorImage,
  sump_pump: SumpPumpImage,
  tankless_water_heater: TanklessWaterHeaterImage,
  thermostat: ThermostatImage,
  trash_compactor: TrashCompactorImage,
  washer: WasherImage,
  water_heater: WaterHeaterImage,
  water_softener: WaterSoftenerImage
} as const;

/**
 * returns the appropriate fallback image source for a product type
 * @param type - product type string
 * @returns image source URL or default ImageIcon
 */
export const getFallbackProductImage = (type: string): string => {
  return (
    fallbackProductImages[type as keyof typeof fallbackProductImages] ||
    ImageIcon
  );
};
